import * as Types from '../../tenants/kwg/generated';

import { MigrationInconsistencyFragmentDoc } from './migrationInconsistencies.fragment.g';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const MigrationInconsistenciesDocument = `
    query MigrationInconsistencies($order: [MigrationInconsistencySortInput!], $first: Int, $after: String, $where: MigrationInconsistencyFilterInput) {
  migrationInconsistencies(
    order: $order
    first: $first
    after: $after
    where: $where
  ) {
    edges {
      node {
        ...MigrationInconsistency
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MigrationInconsistencyFragmentDoc}`;

export const useMigrationInconsistenciesQuery = <
      TData = Types.MigrationInconsistenciesQuery,
      TError = unknown
    >(
      variables?: Types.MigrationInconsistenciesQueryVariables,
      options?: Omit<UseQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.MigrationInconsistenciesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MigrationInconsistencies'] : ['MigrationInconsistencies', variables],
    queryFn: fetcher<Types.MigrationInconsistenciesQuery, Types.MigrationInconsistenciesQueryVariables>(MigrationInconsistenciesDocument, variables),
    ...options
  }
    )};

export const useSuspenseMigrationInconsistenciesQuery = <
      TData = Types.MigrationInconsistenciesQuery,
      TError = unknown
    >(
      variables?: Types.MigrationInconsistenciesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.MigrationInconsistenciesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MigrationInconsistencies'] : ['MigrationInconsistencies', variables],
    queryFn: fetcher<Types.MigrationInconsistenciesQuery, Types.MigrationInconsistenciesQueryVariables>(MigrationInconsistenciesDocument, variables),
    ...options
  }
    )};

export const useInfiniteMigrationInconsistenciesQuery = <
      TData = InfiniteData<Types.MigrationInconsistenciesQuery>,
      TError = unknown
    >(
      variables: Types.MigrationInconsistenciesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.MigrationInconsistenciesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MigrationInconsistencies.infinite'] : ['MigrationInconsistencies.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MigrationInconsistenciesQuery, Types.MigrationInconsistenciesQueryVariables>(MigrationInconsistenciesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteMigrationInconsistenciesQuery = <
      TData = InfiniteData<Types.MigrationInconsistenciesQuery>,
      TError = unknown
    >(
      variables: Types.MigrationInconsistenciesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.MigrationInconsistenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.MigrationInconsistenciesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MigrationInconsistencies.infinite'] : ['MigrationInconsistencies.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MigrationInconsistenciesQuery, Types.MigrationInconsistenciesQueryVariables>(MigrationInconsistenciesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const MigrationInconsistencyEntityTypeCountsDocument = `
    query MigrationInconsistencyEntityTypeCounts {
  migrationInconsistencyEntityTypeCounts {
    entityType
    count
  }
}
    `;

export const useMigrationInconsistencyEntityTypeCountsQuery = <
      TData = Types.MigrationInconsistencyEntityTypeCountsQuery,
      TError = unknown
    >(
      variables?: Types.MigrationInconsistencyEntityTypeCountsQueryVariables,
      options?: Omit<UseQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MigrationInconsistencyEntityTypeCounts'] : ['MigrationInconsistencyEntityTypeCounts', variables],
    queryFn: fetcher<Types.MigrationInconsistencyEntityTypeCountsQuery, Types.MigrationInconsistencyEntityTypeCountsQueryVariables>(MigrationInconsistencyEntityTypeCountsDocument, variables),
    ...options
  }
    )};

export const useSuspenseMigrationInconsistencyEntityTypeCountsQuery = <
      TData = Types.MigrationInconsistencyEntityTypeCountsQuery,
      TError = unknown
    >(
      variables?: Types.MigrationInconsistencyEntityTypeCountsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MigrationInconsistencyEntityTypeCounts'] : ['MigrationInconsistencyEntityTypeCounts', variables],
    queryFn: fetcher<Types.MigrationInconsistencyEntityTypeCountsQuery, Types.MigrationInconsistencyEntityTypeCountsQueryVariables>(MigrationInconsistencyEntityTypeCountsDocument, variables),
    ...options
  }
    )};

export const useInfiniteMigrationInconsistencyEntityTypeCountsQuery = <
      TData = InfiniteData<Types.MigrationInconsistencyEntityTypeCountsQuery>,
      TError = unknown
    >(
      variables: Types.MigrationInconsistencyEntityTypeCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MigrationInconsistencyEntityTypeCounts.infinite'] : ['MigrationInconsistencyEntityTypeCounts.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MigrationInconsistencyEntityTypeCountsQuery, Types.MigrationInconsistencyEntityTypeCountsQueryVariables>(MigrationInconsistencyEntityTypeCountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteMigrationInconsistencyEntityTypeCountsQuery = <
      TData = InfiniteData<Types.MigrationInconsistencyEntityTypeCountsQuery>,
      TError = unknown
    >(
      variables: Types.MigrationInconsistencyEntityTypeCountsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.MigrationInconsistencyEntityTypeCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MigrationInconsistencyEntityTypeCounts.infinite'] : ['MigrationInconsistencyEntityTypeCounts.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MigrationInconsistencyEntityTypeCountsQuery, Types.MigrationInconsistencyEntityTypeCountsQueryVariables>(MigrationInconsistencyEntityTypeCountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};
